module.exports = __webpack_public_path__ + "kayak-logo.png?1c6812da5941738285cb49fee69a7a1c";